module.exports = __webpack_public_path__ + "static/logo-9726c3d54b0a6e814175d8a0280f1ef1.png";